module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"Total":"Totale","orderCreated":"Ordine crato! Le mail di notifica inviate"}}')
  delete Component.options._Ctor
}
